import { useCallback, useEffect, useState } from 'react';

import { OrganisationsAPI } from '@/services/networking/organisations';

function useOrganisationInvitation() {
    const [invitationUrl, setInvitationUrl] = useState<string | null>(null);
    const [invitationId, setInvitationId] = useState<string | null>(null);

    const fetchInvitationUrl = useCallback(async () => {
        const response = await OrganisationsAPI.getOrganisationInvitation();
        const { invitation_url, id } = response.payload;
        setInvitationUrl(invitation_url);
        setInvitationId(id);
    }, []);

    useEffect(() => {
        fetchInvitationUrl();
    }, [fetchInvitationUrl]);

    return { invitationUrl, invitationId };
}

export { useOrganisationInvitation };
